import { render, staticRenderFns } from "./LotNo.vue?vue&type=template&id=4860472c&scoped=true"
import script from "./LotNo.vue?vue&type=script&lang=js"
export * from "./LotNo.vue?vue&type=script&lang=js"
import style0 from "./LotNo.vue?vue&type=style&index=0&id=4860472c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860472c",
  null
  
)

export default component.exports